import { z } from 'zod';

import { validateJSONString } from '@nw/shared/utils';

export const LoginCardConfigSchema = z.object({
  heading: z.string(),
  description: z.string().optional()
});

export const LoginSectionSchema = z.object({
  authentication: z.object({
    method: z.string()
  }),
  fields_config: z.array(z.string()),
  header_img_url: z.string().optional(),
  footer_img_url: z.string().optional(),
  trouble_logging_iframe_url: z.string().optional(),
  phone_number_card_config: LoginCardConfigSchema.optional(),
  otp_card_config: LoginCardConfigSchema.optional(),
  header_logo_alt_text: z.string().optional()
});

export const SeoInfoSchema = z.object({
  title: z.string(),
  metaData: z.array(z.record(z.string())),
  link: z.array(z.record(z.string()))
});

export const BrandingSectionSchema = z.object({
  branding_section_markdown_content: z.string(),
  seo_info: SeoInfoSchema.optional()
});

export const ClientConfigThemeSchema = z.object({
  font_family_type: z.string(),
  custom_styles: z.string()
});

export const LayoutTypeEnum = z.enum([
  'LOGIN_SECTION_LEFT_BRANDING_SECTION_RIGHT',
  'ONLY_LOGIN_SECTION',
  'LOGIN_SECTION_RIGHT_BRANDING_SECTION_LEFT'
]);

export const LoginPageConfigSchema = z.object({
  layout: z.object({
    type: LayoutTypeEnum
  }),
  login_section_config: z
    .string()
    .refine(validateJSONString(LoginSectionSchema, false)),
  branding_section_config: z
    .string()
    .refine(validateJSONString(BrandingSectionSchema, false)),
  theme: z.string().refine(validateJSONString(ClientConfigThemeSchema, false))
});

export const ClientConfigDetailSchema = z.object({
  client_id: z.string(),
  login_page: LoginPageConfigSchema
});
